import { render, staticRenderFns } from "./AdDetail.vue?vue&type=template&id=95e8b8d0&scoped=true&"
import script from "./AdDetail.vue?vue&type=script&lang=js&"
export * from "./AdDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdDetail.vue?vue&type=style&index=0&id=95e8b8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e8b8d0",
  null
  
)

export default component.exports